import React, { useState, useEffect } from 'react';
import API_BASE from '../config';
import { useUser, useAuth } from '@clerk/clerk-react';
import toast from 'react-hot-toast';
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
import Usage from './Usage';
import Pricing from './Pricing';
import WorkspaceUsers from './WorkspaceUsers';
import Workspaces from './Workspaces';

const TABS = [
  { key: 'plan', label: 'Plan' },
  { key: 'usage', label: 'Usage' },
  { key: 'users', label: 'Users' },
  { key: 'workspaces', label: 'Workspaces' },
];

export default function Account() {
  const { id } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const activeTab = searchParams.get('tab') || 'plan';

  const setTab = (key) => {
    setSearchParams({ tab: key }, { replace: true });
  };

  const tabBtn = (t) => {
    const active = activeTab === t.key;
    return (
      <button
        key={t.key}
        onClick={() => setTab(t.key)}
        style={{
          background: 'none',
          border: 'none',
          padding: '0.6rem 0.25rem',
          marginRight: '1.75rem',
          fontSize: '0.9rem',
          fontWeight: active ? 600 : 500,
          color: active ? '#8B1A1A' : '#666',
          borderBottom: active ? '2px solid #8B1A1A' : '2px solid transparent',
          cursor: 'pointer',
          fontFamily: 'inherit',
        }}
      >
        {t.label}
      </button>
    );
  };

  return (
    <div style={{ padding: '2rem', maxWidth: '1100px', margin: '0 auto', boxSizing: 'border-box', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif' }}>
      <h1 style={{ fontSize: '1.6rem', fontWeight: 500, margin: '0 0 0.4rem', color: '#1A1A1A' }}>Account</h1>
      <p style={{ margin: '0 0 1.5rem', color: '#888', fontSize: '0.88rem' }}>Manage your plan, usage, users, and workspaces.</p>

      <div style={{ borderBottom: '1px solid #E8E4E0', marginBottom: '1.75rem', display: 'flex', flexWrap: 'wrap' }}>
        {TABS.map(tabBtn)}
      </div>

      <div>
        {activeTab === 'plan' && <Pricing embedded={true} />}
        {activeTab === 'usage' && <Usage embedded={true} />}
        {activeTab === 'users' && <WorkspaceUsers embedded={true} />}
        {activeTab === 'workspaces' && <Workspaces />}
      </div>
    </div>
  );
}
